import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducer";
import thunk from "redux-thunk";
import { verifyAuth } from "./auth/authActions";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

const persistConfig = {
    key: "root",
    storage,
    // ROMI-1924 — never persist `async` (it holds `initialized`). If persisted, the app
    // boots with initialized=true and renders before /api/me finishes, so a still-null
    // current_staff on a /booking route wrongly redirects to "/". Keep it false on boot.
    blacklist: ["modals", "async"],
    version: 1, // Increment this when you change state shape
    migrate: (state) => {
        // Auto-fix staff if it's an object instead of array
        if (state && state.auth && typeof state.auth.staff === 'object' && !Array.isArray(state.auth.staff)) {
            return Promise.resolve({
                ...state,
                auth: {
                    ...state.auth,
                    staff: [],
                },
            });
        }
        return Promise.resolve(state);
    },
};

export function configureStore() {
    const persistedReducer = persistReducer(
        persistConfig,
        rootReducer(history)
    );

    const store = createStore(
        persistedReducer,
        composeWithDevTools(applyMiddleware(thunk))
    );

    let persistor = persistStore(store);

    store.dispatch(verifyAuth());

    return { store, persistor };
}
